export const companies = {
  company_name: "企業名",
  index: {
    company_search: '企業検索'
  },
  form: {
    input_labels: {
      id: '企業コード',
      name: '企業名',
      industries: '業種',
      representative_name: '代表者名',
      zip_code: '所在地',
      prefectures: '都道府県',
      city: '市区町村',
      address_number: '番地',
      house: 'マンション名・建物名など',
      tel: '電話番号（ハイフンあり）',
      mail_address: 'メールアドレス',
      homepage_url: 'ホームページ',
      memo: 'メモ（非表示）',
      bank_name: '銀行名',
      branch_name: '店番名',
      bank_account_type: '普通・当座',
      bank_account: '口座番号',
      bank_account_holder: '口座名義',
      login_id: 'ログインID (半角英数字8文字以上)',
      status: '有効・無効'
    },
    input_placeholder: {
      name: '企業名',
      industries: '業種',
      representative_name: '代表者名',
      zip_code: '郵便番号（ハイフンなし）',
      prefectures: '都道府県',
      city: '市区町村',
      address_number: '番地',
      house: 'マンション名・建物名など',
      tel: '電話番号（ハイフンあり）',
      mail_address: 'メールアドレス',
      homepage_url: 'ホームページ',
      memo: 'メモ（非表示）',
      bank_name: '銀行名',
      branch_name: '店番名',
      bank_account_type: '普通・当座',
      bank_account: '口座番号',
      bank_account_holder: '口座名義',
      login_id: 'ログインID',
      status: '有効・無効'
    },
    zip_code: '郵便番号',
    login_id: 'ログインID',
    bank_info: '振込先情報',
    account_info: 'アカウント情報（管理画面に入る際に必要です）',
    back_account_type: {
      nomarl_account: '普通',
      current_account: '当座'
    },
    btn_search_by_zip_code: '郵便番号から検索',
  },
  detail_fields: {
    company_name: '企業名',
    industries: '業種',
    genre: 'ジャンル',
    seat: '席数',
    representative_name: '代表者名',
    address: '所在地',
    tel: '電話番号',
    mail_address: 'メールアドレス',
    homepage_url: 'ホームページ',
    memo: 'メモ',
    bank_name: '銀行名',
    branch_name: '店番号',
    bank_account_type: '普通・当座',
    bank_account: '口座番号',
    bank_account_holder: '口座名義',
    register_date: '初回登録日',
    last_login_date: '最終ログイン日',
    login_id: 'ログインID',
    password: 'パスワード',
    status: '有効・無効',
    month_kokoron: '今月のココロン',
    cumulative_kokoron: '累計ココロン'
  },
  owned_kokoron: '所有ココロン'
}
